// hc-soldout V1.2.0
function HcUpdateCrossedOut(opts) { 
  const {
    variants, // {{ product.variants | json }}
    options, // {{ product.options | json }}
    optionNames, // ['Size'] the options to update
    selectors, // Selectors
    hierarchy: hierarchyConf, // ['Color', 'Size'] .. in order from top to bottom
    onDisable
  } = opts;
  
  const {
    radioAllElements: radioAllSelector, // A selector to match all the radio buttons
    radioElement: radioSelector, // the input element with the swatch (index: number): string
    radioContainer: swatchSelector // the parent of the radio button to update 
  } = selectors; 

  const customDisabler = typeof onDisable == 'function' && onDisable;
  const defaultDisabler = (el, shouldDisable) => el.closest(swatchSelector).classList.toggle('hc-soldout-option', shouldDisable);
  
  const disablerFn = customDisabler || defaultDisabler;
  
  // Get option index by name 
  const getIndex = optionName => options.findIndex(op => op.toLowerCase() == optionName.toLowerCase())  

  
  const FilterVariantsByOption = (variantOptions, filterFunction) => {
    const requestedOptionIndex = variantOptions.findIndex(opt => opt == "$x");
    if (requestedOptionIndex < 0) throw new TypeError("$x must be passed to the options array");
    
    return variants
    .filter(variant => {
      for (const [index, opt] of variant.options.entries()) {
        if (!filterFunction(variant) || (variantOptions[index] !== opt && index !== requestedOptionIndex)) return false;
      }
      return true;
    })
    .map(variant => variant.options[requestedOptionIndex]);
  }
  
  // Get available option for $x in ["red", "$x", "long"] 
  const getAvailableValuesForOption = variantOptions => FilterVariantsByOption(variantOptions, variant => variant.available);
  const getAllValuesForOption = variantOptions => FilterVariantsByOption(variantOptions, variant => true);
  
  // Heirarchy
  const hierarchy = hierarchyConf || options;
  
  const buildAvailablityGraph = () => {
    
    const graph = {};
        
    for (const variant of variants) {
      if (!variant.available) continue;
      let currentNode = graph;
      for (const [i, option] of hierarchy.entries()) {
        const optionIndex = options.findIndex(optionName => optionName == option);
        const isLast = hierarchy.length == (i+1);
        if (optionIndex < 0) return false;
        const value = variant.options[optionIndex];
        currentNode[value] = isLast ? variant : {};
        currentNode = currentNode[value];
      }
    }
    
    return graph;
  }
  
  window.hcGraph = buildAvailablityGraph();
  
  // Get an array of the selected options similar to variant.options 
  const getSelectedOptions = () => options.map((name, index) => document.querySelector(radioSelector(index) + ':checked') && document.querySelector(radioSelector(index) + ':checked').value);
  
  function shouldSoldoutUpdate(optionIndex, optionSelector, newlyPickedSwatchElement) {
    const isSameOption = newlyPickedSwatchElement && newlyPickedSwatchElement.querySelector(optionSelector);
    return (!isSameOption);
  }
  
  function fireUpdateEvent(optionIndex, optionSelector,availableOptions) {
    const e = new CustomEvent('hc-soldout:update',  {
      detail: {
        optionIndex, 
        optionSelector,
        availableOptions,
        optionName: options[optionIndex].toLowerCase()
      }
    });
    document.dispatchEvent(e);
  }
  
  function updateOptions(selectedOptions, changedOption) {
    
    const optionSelectors = optionNames.map(optionName => {
      const optIndex = getIndex(optionName)
      return [optIndex, radioSelector(optIndex)];
    }); 
    
    for (const [requestedOptionIndex, optionSelector] of optionSelectors) {
      const e = new CustomEvent('hc-soldout:update-0',  {
        detail: {
          optionIndex: requestedOptionIndex, 
          optionSelector,
          optionName: options[requestedOptionIndex].toLowerCase()
        }
      });
      document.dispatchEvent(e);
      
      if (!shouldSoldoutUpdate(requestedOptionIndex, optionSelector, changedOption)) continue;
      
      const availableValues = getAvailableValuesForOption(selectedOptions.map((val, index) => index === requestedOptionIndex ? "$x" : val));
      
      const possibleValues = getAllValuesForOption(selectedOptions.map((val, index) => index === requestedOptionIndex ? "$x" : val));
      
      const radios = document.querySelectorAll(optionSelector);
      radios.forEach(el => disablerFn(el, !availableValues.includes(el.value), !possibleValues.includes(el.value)));
      
      fireUpdateEvent(requestedOptionIndex, optionSelector, availableValues);
    }
  }
  
  function onLoad() {
    updateOptions(getSelectedOptions());
    document.body.addEventListener('change', e => {
      if (e.hcIgnore) return;
      if (e.target.closest(radioAllSelector)) {
        let selectedOptions = getSelectedOptions();
        updateOptions(selectedOptions, e.target.closest(swatchSelector));
      }
    });
  }
  
  window.addEventListener('DOMContentLoaded', onLoad);
}